import { Trans } from '@lingui/react/macro';
import { InfoCircle } from '@untitledui/icons/InfoCircle';

import type { ScreenerCycleDto } from '@/api/core-api/types.gen';

import { Tooltip, TooltipTrigger } from '@/components/base/tooltip/tooltip';

interface ScreenerLimitDisplayProps {
  data: ScreenerCycleDto;
}

/**
 * Inline display showing survey limit status.
 */
export function ScreenerLimitDisplay({ data }: ScreenerLimitDisplayProps) {
  const { limit, screenerCount } = data;

  return (
    <div className="text-tertiary-600 flex items-center gap-2 text-sm">
      <span>
        <Trans>You can apply max {limit} projects a day</Trans>
      </span>
      <span className="font-semibold text-primary">
        {screenerCount}/{limit}
      </span>
      <Tooltip
        title={
          <Trans>
            You can apply to up to {limit} projects within a 24-hour period.
            This limit resets after 24 hours.
          </Trans>
        }
        placement="bottom"
      >
        <TooltipTrigger>
          <InfoCircle className="text-tertiary-500 size-4 cursor-help" />
        </TooltipTrigger>
      </Tooltip>
    </div>
  );
}
